import React, { useEffect, useState, useMemo } from 'react';
import { toast } from 'react-toastify';
import { isEmpty, isArray, get } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { ConfirmationDialogRaw } from '~/components';
import { Spinner } from '~/components';

import { RadioGroup } from '~/components/Form';

import ListTransfer from '../ListTransfer';

import api from '~/services/api';

import { Wrapper, FormWrapper, WrapperRadioGroup } from './styles';

export default function MyForm({ data, reference, close, cancelarAcao }) {

  const [units, setUnits] = useState([]);

  const [organ, setOrgan] = useState({ orga_codigo: '', orga_nome: '' });

  const cells = useMemo(
    () => [
      { id: 'fatu_codigo', label: 'Pré-fatura' },
      { id: 'orga_nome', label: 'Órgão' },
    ],
    []
  );

  const [modoIntegracaoSIAD, setModoIntegracaoSIAD] = useState('');
  const [atualizaStatusSIAD, setAtualizaStatusSIAD] = useState(false);

  const [formato, setFormato] = useState('pdf');

  const [isLoading, setIsLoading] = useState(false);

  const [isLoadingPrint, setIsLoadingPrint] = useState(false);

  //ConfirmationDialogRaw o registro do geral
  const [tituloConfirmationDialogRaw, setTituloConfirmationDialogRaw] = React.useState('O DOWNLOAD DO(S) ARQUIVO(S) PODE DEMORAR!');
  const [mensagemConfirmationDialogRaw, setMensagemConfirmationDialogRaw] = React.useState('Deseja confirmar a operação?');
  const [openConfirmationDialogRaw, setOpenConfirmationDialogRaw] = React.useState(false);
  const [valueConfirmationDialogRaw, setValueConfirmationDialogRaw] = React.useState("CLICK-OK");
  const [paramSubmit, setParamSubmit] = React.useState();

  async function openWinBaixarArquivo2(urls, formato) {
    // Gera um ID único

    const links = []; // Array para armazenar os links

    function generateUniqueId() {
      return 'id-' + Math.random().toString(36).substr(2, 9);
    }

    async function baixarMultiplosArquivosComDelay(urls, delay = 1000) {
      toast.success('Processo sendo executado em segundo plano! ');
      await urls.forEach((url, index) => {
        setTimeout(() => {
          const link = document.createElement('a');

          if (formato === "pdf") {
            link.href = url.cosi_url_aplic_rel_rad_getpdf;
          } else {
            link.href = url.cosi_url_aplic_rel_rad_getexcel;
          }

          // Define o ID único
          link.id = generateUniqueId();

          link.download = '';
          document.body.appendChild(link);

          links.push(link); // Adiciona o link ao array

          link.click();

          // document.body.removeChild(link);
          toast.success(`Baixando arquivo ${url.fatu_codigo} -  ${url.orga_nome} `);
        }, index * delay);  // Delay entre cada download
      });
      setIsLoadingPrint(true);
    }
    await baixarMultiplosArquivosComDelay(urls, 2500);

    // Remover todos os links após um atraso
    setTimeout(() => {
      links.forEach(link => {
        document.body.removeChild(link); // Remove os links do array
      });
    }, 60000); // Ajuste o tempo conforme necessário

  }


  async function openWinBaixarArquivo(urls) {
    // Gera um ID único
    function generateUniqueId() {
      return 'id-' + Math.random().toString(36).substr(2, 9);
    }
    async function baixarMultiplosArquivosComDelay(urls, delay = 1000) {
      toast.success('Processo sendo executado em segundo plano! ');
      await urls.forEach((url, index) => {
        setTimeout(() => {
          const link = document.createElement('a');
          link.href = url.cosi_url_aplic_rel_rad_getpdf;

          // Define o ID único
          link.id = generateUniqueId();

          link.download = '';
          document.body.appendChild(link);
          link.click();


          document.body.removeChild(link);
          toast.success(`Baixando arquivo ${url.fatu_codigo} -  ${url.orga_nome} `);
        }, index * delay);  // Delay entre cada download
      });
      setIsLoadingPrint(true);
    }
    await baixarMultiplosArquivosComDelay(urls, 2500);
  }


  const historicoPeriodo = React.useCallback(async () => {
    let codigos = units.map((unity) => unity.cosi_url_aplic_rel_rad_getpdf);

    let codigosObj = units.map((unity) => {
      return {
        cosi_url_aplic_rel_rad_getexcel: unity.cosi_url_aplic_rel_rad_getexcel,
        cosi_url_aplic_rel_rad_getpdf: unity.cosi_url_aplic_rel_rad_getpdf,
        fatu_codigo: unity.fatu_codigo,
        orga_nome: unity.orga_nome
      }
    }
    );

    openWinBaixarArquivo2(codigosObj, formato);


  }, [units, formato]);


  const execHandleConfirmar = (param) => {
    setParamSubmit(param);
    setOpenConfirmationDialogRaw(true);
  };

  const handleConfirmationDialogRaw = (newValue) => {
    //console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (newValue) {
      setValueConfirmationDialogRaw(newValue);
      setIsLoading(false);
      if (newValue === 'CLICK-OK') {
        //handleSubmitConfirmar();
        setIsLoading(true);
        handleSubmit(paramSubmit)
      }
    } else {
      cancelarAcao();
      setIsLoading(false);
    }

  };

  async function handleSubmitPegunta(event, param) {
    await setIsLoading(true);
    await execHandleConfirmar(param);
  }

  async function handleSubmit(event) {
    try {
      async function Enviar() {
        await historicoPeriodo();
      }
      await Enviar();
    } catch (err) {
      await setIsLoading(false);
      await cancelarAcao();
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  async function getConfigSistema() {
    try {
      //setIsLoading(true);
      const response = await api.get(`/configsistema`);
      const statusRetorno = get(
        response,
        'data.cosi_consul_libera_abast_siad',
        ''
      );
      //await setIsLoading(false);
      if (String(statusRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }
      if (response && !isEmpty(response.data)) {
        if (String(response.data.cosi_consul_libera_abast_siad) === '1') {
          setModoIntegracaoSIAD('1');
        } else {
          setModoIntegracaoSIAD('0');
        }
      }
    } catch (err) {
      //setIsLoading(false);
      setModoIntegracaoSIAD('0');
      toast.error(` ${err} `);
    }
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getConfigSistema();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [atualizaStatusSIAD]);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (isLoadingPrint) {

        setTimeout(() => {
          setIsLoading(false);
          close();
        }, 1000);  // Delay entre cada download


      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [isLoadingPrint]);



  async function handleUpdateBaseSiad() {
    await setAtualizaStatusSIAD(!atualizaStatusSIAD);
  }

  useEffect(() => {
    reference.current.setData(data);
    handleUpdateBaseSiad();
  }, []);

  // Captura do event para fazer event.preventDefault()
  const handleFormSubmit = (event) => {
    event.preventDefault();  // Evita o comportamento padrão do HTML
    reference.current.submitForm();  // Chama o método de envio do Unform
  };

  return (
    <>

      <> {/* <> Para confirmação do form */}
        <ConfirmationDialogRaw
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Sim"
          textoBtnCancel="Não"
        />
      </> {/* <> Para confirmação do form */}

      {isLoading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (

        <Wrapper>
          <FormWrapper ref={reference} initialData={data} onSubmit={(event) => handleSubmitPegunta(event)}>

            <WrapperRadioGroup>
              <RadioGroup
                name="formato"
                label="Formato"
                options={[
                  { label: 'PDF', value: 'pdf' },
                  { label: 'Excel', value: 'xls' },
                ]}
                defaultValue="pdf"
                serialize={(value) => value}
                getValue={(value) => setFormato(value)}
                row
              />
            </WrapperRadioGroup>

            <ListTransfer
              search
              grid
              dense
              cells={cells}
              url="radadmdadosfaturamentoseplag"
              label="orga_nome"
              unique="fatu_codigo"
              leftTitle="Pré-faturas disponíveis"
              rightTitle="Pré-faturas selecionadas"
              onCallback={(value) => setUnits(value)}
              // maxWidth={38}
              maxHeight={330}
              reset={isEmpty(units)}
              query={{
                wherefield: ['fatu_status'],
                valuewherefield: ["1, 201, 202, 2, 3, 302, 303"],
                typewherefield: ['IN'],
              }}
              showCount
            />


          </FormWrapper>
        </Wrapper>
      )}
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
